import debug from 'debug'

export const adsDebug = debug('ads')
